// extracted by mini-css-extract-plugin
export default {"OtpInput":"OtpInput_OtpInput__VtyJm","otpInput":"OtpInput_otpInput__Y-+he"};